import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import styles from './Layout.module.scss'
import Header from '../Header/Header'
import { useSelector } from '../../store'

const Layout = () => {
  const theme = useSelector((state) => state.ui.theme)

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  return (
    <div className={styles.wrapper}>
      <Header />
      <div className={styles.layout}>
        <Outlet />
      </div>
    </div>
  )
}

export default Layout
